import React, { useEffect } from "react";
import { connect, ConnectedProps } from "react-redux";
import { Redirect, RouteComponentProps } from "react-router";
import styled from "styled-components";
import OutlineButton from "sweet-web/components/universal/Button/OutlineButton";
import { colors } from "sweet-web/lib/styles";
import { RootState } from "sweet-web/redux";
import * as selectors from "sweet-web/redux/selectors";
import Chat from "./Chat";
import ChatBooking from "./ChatBooking";
import ChatHeader from "./ChatHeader";
import SelectChat from "./SelectChat";

const Wrapper = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  padding-top: 60px;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  @media screen and (max-width: 600px) {
    /* mobile styling */
    /* padding-top: 50px; */
  }
`;

const EmptyWrapper = styled.div`
  width: 100%;
  height: ${window.innerHeight - 60}px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const PlaceholderMessage = styled.h1`
  font-size: 17px;
  font-weight: 600;
  color: ${colors.nearBlack};
  text-align: center;
  margin-bottom: 15px;
`;

type Props = RouteComponentProps & ConnectedProps<typeof connector>;

const Inbox: React.FC<Props> = props => {
  const { chatId } = props.match.params as { chatId: string };
  const { userType, chatIds, chat } = props;

  useEffect(() => {
    if (chatIds.length > 0 && !chatId && window.innerWidth > 600) {
      props.history.push(`/c/${chatIds[0]}`);
    }
  }, [chatIds]);

  const buildListing = () => {
    props.history.push(`/listings`);
  };

  const discover = () => {
    props.history.push(`/`);
  };

  return (
    <React.Fragment>
      {chatId && chat && window.innerWidth > 600 && (
        <React.Fragment>
          <Wrapper>
            {window.innerWidth > 600 && <SelectChat />}
            {window.innerWidth > 600 && chat.booking && <ChatBooking />}
            <Chat />
          </Wrapper>
          <ChatHeader />
        </React.Fragment>
      )}
      {chatIds.length > 0 && !chatId && window.innerWidth <= 600 && (
        <SelectChat />
      )}
      {!(chatId && chat) && userType === "VENUE" && (
        <EmptyWrapper>
          <PlaceholderMessage>
            No new inquiries, but check back soon
          </PlaceholderMessage>
          <OutlineButton
            title={"Keep Building Listing"}
            onClick={buildListing}
            link={true}
          />
        </EmptyWrapper>
      )}
      {!(chatId && chat) && userType === "USER" && (
        <EmptyWrapper>
          <PlaceholderMessage>
            Chat with the best bars, clubs,
            <br />
            and restaurants for your event
          </PlaceholderMessage>
          <OutlineButton
            title={"Browse Venues"}
            onClick={discover}
            link={true}
          />
        </EmptyWrapper>
      )}
    </React.Fragment>
  );
};

const mapState = (state: RootState, ownProps: RouteComponentProps) => {
  const { chatId } = ownProps.match.params as { chatId: string };

  return {
    chatIds: selectors.chatIds(state),
    chat: selectors.chat(chatId)(state),
    userType: selectors.userType(state)
  };
};
const connector = connect(mapState);

export default connector(Inbox);
